export enum TransactionLogActionTypes {
  SET_FILTER = "@@TransactionLog/SET_FILTER",
  SET_DATE = "@@TransactionLog/SET_DATE",
  SET_PAGE = "@@TransactionLog/SET_PAGE",
  SET_DETAILS = "@@TransactionLog/SET_DETAILS",
  SET_SHOW_POSITION = "@@TransactionLog/SET_SHOW_POSITION",
  RESET_STATE = "@@TransactionLog/RESET_STATE"
}
